import React from "react";
import classnames from "classnames";
import { Field } from "react-final-form";
import ValidationError from "./ValidationError";
import "./style.scss";
import SubmitError from "./SubmitError";

class FieldSelect extends React.Component {
  render() {
    const { props } = this;

    return (
      <Field name={props.name} validate={props.validate}>
        {({ input, meta }) => (
          <div
            className={classnames(
              "ant-select-selection-container",
              props.className
            )}
          >
            <div>
              <label>{props.label}</label>
            </div>
            <span
              className={classnames({
                "ant-select-selection-container__error":
                  (meta.error && meta.dirty) ||
                  (meta.submitFailed && !meta.valid) ||
                  (meta.submitError && !meta.dirtySinceLastSubmit),
                "ant-select-selection-container__valid":
                  meta.visited && meta.valid
              })}
            >
              <select
                {...input}
                className={classnames(
                  {
                    __error:
                      (meta.error && meta.dirty) ||
                      (meta.submitFailed && !meta.valid) ||
                      (meta.submitError && !meta.dirtySinceLastSubmit),
                    __valid: meta.visited && meta.valid
                  },
                  "ant-select-selection"
                )}
                placeholder={props.placeholder}
                disabled={props.disabled}
                readOnly={props.readOnly}
                onBlur={this.props.onChange}
              >
                {this.props.children}
              </select>
            </span>
            <SubmitError name={props.name} />
            <ValidationError meta={meta} />
          </div>
        )}
      </Field>
    );
  }
}

export default FieldSelect;

/*
      <div className={classnames("form-group", props.className)}>
        <div>
          <label>{props.label}</label>
        </div>
        <Field
          name={props.name}
          validate={props.validate}
          component="select"
          className="ant-select-selection"
          style={{ width: "100%" }}
        >
          {props.children}
        </Field>
      </div>*/



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Form/FieldSelect.js